import React from 'react'
import { Growl } from 'primereact/growl';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import {ScrollPanel} from 'primereact/scrollpanel';

import servicioFormatos from '../servicios/ServicioFormatos';
import servicioReceptor from '../servicios/ServicioReceptor';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import servicioMaterial from '../servicios/ServicioMaterial';
import servicioAtributo from '../servicios/ServicioAtributo';
import servicioPagos from '../servicios/ServicioPagos';
import Receptor from './Receptor';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

export class FacturacionPagos extends React.Component {

  constructor() {
    super();
    this.state = {
      listaRegimenFiscalReceptor:[],
      mostrarMoldaReceptor: false,
      receptor: {},
      erroresRequeridos: {},
      valorencontrado: null,
      listaReceptor: [],
      listaTabla: null,
      usosCfdi: [],
      erroresFrmDatos: [],
      urlBusquedaReceptor: 'receptor/buscar_receptor_por_rfc.json',
      urlBusquedaUsosCfdi: 'usocfdi40/uso_cfdi_por_rfc.json',
      urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
      comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
      conceptos: [],
      concepto: { atributos: {} },
      listaMateriales: [],
      paginacion: {},
      listaAtributos: [],
      indexConcepto: null,
      botonEditarConcepto: false,
      tipoDeComprobante:  {},
      formaPago:{},
      listaReceptorConfirmacion: [],
      mostrarModalResultado: false,
      listaResultados: [],
      erroresFrmDatosFiscales: {},
      urlRegimenFiscal: 'regimen/usocfdi_rfc.json',
      urlValidarReceptor40: 'receptor/validar_receptor40.json'
     

    };
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }



  preguardarReceptor = () => {
    this.setState({ receptor: {}, mostrarMoldaReceptor: true });
  }

  buscarReceptorLike = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      }
      else {
        servicioReceptor.buscarReceptorLike({ rfc: valor.query.toUpperCase() }).then(response => {
          if (response.data.error) {
            this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          } else {
            this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          }
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }

    }, 250);
  }

  cargarValores = (event) => {
    if (event.value.rfc !== undefined) {
      const { receptor } = this.state;
      receptor['rfc'] = event.value.rfc;
      this.setState({ receptor });
      this.setState({ listaTabla: [event.value] });
      this.buscarReceptor();
    }
    this.setState({ listaReceptor: event.value })
  }

  

  columnaEditarReceptor = (rowData, column) => {
    return <div>
      <Button tooltip="Editar receptor" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.preEditarReceptor.bind(this, rowData)}></Button>
    </div>;
  }

  preEditarReceptor = (objeto) => {
    this.setState({ receptor: objeto, mostrarMoldaReceptor: true });
  }

  guardarReceptor = () => {
    const { receptor } = this.state;
    const resultadoValidacion = this.validarRequeridos(receptor);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      servicioReceptor.guardarReceptor(receptor).then(response => {
        if (response.data.error) {
          this.growl.show({ life: 8000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
        } else {
          this.growl.show({ life: 6000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
          this.setState({ receptor: response.data.objeto, mostrarMoldaReceptor: false, erroresRequeridos: {}, listaReceptor: [] });
        }
      })
    }

  }

  validarRequeridos = (receptor) => {
    const erroresRequeridos = {};
    const mensajesError = [];
    let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

    if (!receptor.rfc) {
      erroresRequeridos.rfc = "El rfc es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Rfc de Receptor', detail: erroresRequeridos.rfc });

    }

    if (!patron.test(receptor.rfc)) {
      mensajesError.push({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física o Persona Moral' });
      erroresRequeridos.rfc = "El rfc es inválido";
    }

    if (!receptor.nombre) {
      erroresRequeridos.nombre = "El nombre es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Nombre de Receptor', detail: erroresRequeridos.nombre });

    }

    if (!receptor.correo) {
      erroresRequeridos.correo = "El correo es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Correo de Receptor', detail: erroresRequeridos.correo });
    }

    if (Object.keys(erroresRequeridos).length) {
      this.growl.show(mensajesError);
    }

    return erroresRequeridos;
  }

  nuevoConcepto = () => {
    this.buscar_materiales();
    this.setState({ concepto: { cantidad: 0.00, total: 0.00, costo: 0.00, atributos: {} }, modalConceptos: true, listaAtributos: [], botonEditarConcepto: false });
  }

  buscar_materiales = () => {
    let { paginacion } = this.state;
    paginacion["registrosPorPagina"] = 500;
    servicioMaterial.paginacion(paginacion).then(response => {
      if (response.data.objeto != null)
        this.setState({ listaMateriales: response.data.objeto.datos });
    });
  }

  buscar_atributos = (event) => {
    let { listaAtributos, concepto } = this.state;
    concepto.ingresodiverso = event.target.value
    this.lista_atributos(concepto, listaAtributos, false);

  }

  lista_atributos = (obj, arrayr, modalTrue) => {
    servicioAtributo.buscarAtributos(obj.ingresodiverso).then((response) => {
      if (response.data.error === false) {
        arrayr = response.data.lista
        if (modalTrue){
          this.setState({ concepto: obj, modalConceptos: true, listaAtributos: arrayr });

        }
        else{
          obj.atributos={};
          obj.iva=0.0;
          obj.isr=0.0;
          obj.totalSumaIva=0.0;
          obj.totalRetenido=0.0;
          obj.totalIva=0.0;
          obj.total=0.0;
          obj.costo=0.0;
          this.setState({ concepto: obj, listaAtributos: arrayr });
        }
      }
    }).catch((error) => {

    });
  }

  asignarValorLista = (event) => {
    let { concepto } = this.state;
    let nombrePropiedad = event.target.name;
    let valorPropiedad = event.target.value;
    if (valorPropiedad && typeof valorPropiedad !== 'object')
      valorPropiedad = valorPropiedad.toUpperCase();
    concepto.atributos[nombrePropiedad] = valorPropiedad;
    this.setState({ concepto });
  }

  guardarConcepto = () => {
    let { concepto, conceptos, comprobante } = this.state;
    const resultadoValidacion = this.validar_formulario_concepto(concepto);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      conceptos.push(concepto);
      servicioPagos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante });
      });



    }

  }

  editarConcepto = () => {
    const { concepto, comprobante, indexConcepto, conceptos } = this.state;
    const resultadoValidacion = this.validar_formulario_concepto(concepto);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      conceptos[indexConcepto].cantidad = concepto.cantidad;
      conceptos[indexConcepto].concepto = concepto.concepto;
      conceptos[indexConcepto].costo = concepto.costo;
      conceptos[indexConcepto].total = concepto.total;
      conceptos[indexConcepto].ingresodiverso = concepto.ingresodiverso;
      conceptos[indexConcepto].atributos = concepto.atributos;
      conceptos[indexConcepto].descripcionDetallada = concepto.descripcionDetallada;
      servicioPagos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante, botonEditarConcepto: false });
      });
    }
  }

  realizar_calculos_cantidad_total = () => {
    let { concepto } = this.state;
    servicioPagos.realizar_calculos_cantidad_total(concepto).then(response => {
      if (response.data.error)
        this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ concepto: response.data.objeto });

    });
  }

  validar_formulario_concepto = (concepto) => {
    const erroresConcepto = {};
    if (!concepto.cantidad)
      erroresConcepto.cantidad = "Cantidad es requerida";

    if (!concepto.ingresodiverso || concepto.ingresodiverso === undefined)
      erroresConcepto.ingresodiverso = "Concepto requerido";

    if (!concepto.costo)
      erroresConcepto.costo = "Costo es requerida";

    return erroresConcepto;
  }

  columnaEditarConcepto = (rowData, column) => {
    return <div>
      <Button tooltip="Editar concepto" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.pre_editar.bind(this, rowData)}></Button>
      <Button tooltip="Eliminar concepto" type="button" icon="pi-md-delete" className="p-button-danger" onClick={this.pre_eliminar.bind(this, rowData)}></Button>
    </div>;
  }

  pre_editar = (objeto) => {
    let { concepto, listaAtributos, conceptos } = this.state;
    concepto = objeto;
    const index = conceptos.findIndex(con => con === objeto);

    this.lista_atributos(concepto, listaAtributos, true);

    this.setState({ concepto, indexConcepto: index, modalConceptos: true, botonEditarConcepto: true })
  }

  pre_eliminar=(objeto)=>{
    let { conceptos,comprobante } = this.state;
    const index = conceptos.findIndex(con => con === objeto);
    conceptos.splice(index, 1);
    if(conceptos.length>0){
      servicioPagos.obtner_comprobante({ comprobante: comprobante, diversos: conceptos }).then(response => {
        this.setState({ modalConceptos: false, listaAtributos: [], conceptos: response.data.objeto.diversos, comprobante: response.data.objeto.comprobante, botonEditarConcepto: false });
      });
    }else{
      this.setState({
        comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } }     
      });
    }
   
  }

  columna_valor_unitario = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.valorUnitario)}</div>;
  }

  columna_costo = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.importe)}</div>;

  }

  total_iva = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.totalIva)}</div>;
  }

  total_retenido = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.iva)}</div>

  }

  total_retenido_isr= (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.isr)}</div>

  }

  total = (rowData, column) => {
    return <div style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(rowData.totalSumaIva)}</div>;
  }

  prefactura=()=>{
    let { receptor, conceptos,tipoDeComprobante, formaPago} = this.state;
    const errores = this.validar_facturacion(receptor, conceptos,tipoDeComprobante, formaPago);
    this.setState({ erroresFrmDatos: errores });
    if (!Object.keys(errores).length) {
      this.setState({ confirmacionFacturacion: true, listaReceptorConfirmacion: [receptor] });
    }
  }

  validar_facturacion=(receptor, conceptos,tipoDeComprobante, formaPago)=>{
    const erroresConcepto = {};
    const mensajesError = [];
    if (!receptor.rfc) {
      erroresConcepto.rfc = "El receptor es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Receptor', detail: erroresConcepto.rfc });
    }


    if (conceptos.length === 0) {
      erroresConcepto.conceptos = "Debes agregar un concepto requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Concepto', detail: erroresConcepto.conceptos });
    }

    if (!receptor.usoCfdi) {
      erroresConcepto.usoCfdi = "El uso del CFDI es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.usoCfdi });
    }


    if (!receptor.regimenFiscalReceptor) {
      erroresConcepto.regimenFiscalReceptor = "El regimen fiscal receptor es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.regimenFiscalReceptor });
    }

    if(!tipoDeComprobante.name){
      erroresConcepto.tipoDeComprobante = "El tipo de comprobante es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Tipo de Comprobante', detail: erroresConcepto.tipoDeComprobante });
    }

    if(!formaPago.name){
      erroresConcepto.formaPago = "La forma de pago es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Forma de Pago', detail: erroresConcepto.formaPago });
    }

    if (Object.keys(erroresConcepto).length) {
      this.growl.show(mensajesError);
    }
    return erroresConcepto;
  }

  facturar=()=>{


    const { comprobante, receptor, conceptos ,tipoDeComprobante, formaPago} = this.state;
    var receptorEnvio = JSON.parse(JSON.stringify(receptor));
    let usoCfdi = receptorEnvio.usoCfdi.clave;
    delete receptorEnvio['usoCfdi'];
    receptorEnvio.usoCfdi = usoCfdi;
    comprobante['tipoDeComprobante']=tipoDeComprobante.code;
    comprobante['formaPago']=formaPago.code;
    let regimenFiscalReceptor =  receptorEnvio.regimenFiscalReceptor;
    delete receptorEnvio['regimenFiscalReceptor'];
    receptorEnvio.regimenFiscalReceptor = regimenFiscalReceptor.id;
    
    servicioPagos.facturar_comprobante({ comprobante: comprobante, receptor: receptorEnvio, diversos: conceptos }).then(response=>{
      let respuesta = response.data;
      let listaResultados = respuesta.lista;
      this.setState({ mostrarModalResultado: true,confirmacionFacturacion: false });
      this.setState({ listaResultados: listaResultados,  comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
        conceptos: [],receptor:{},listaReceptor:[],listaTabla:[],listaReceptorConfirmacion:[], tipoDeComprobante:  {},formaPago:{}});
      
      
    })


  }

  cerrar_modal_confirmacion_facturacion=()=>{
   this.setState({confirmacionFacturacion: false});
  }

  cerrarModalResultados=()=>{
    this.setState({ mostrarModalResultado: false });
  }

  templateDescargaArchivos = (rowData, column) => {
    if(rowData.error === false)
    return <div><Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button></div>;
  }

  descargaArchivos = (rowData) => {
    let { urlDescargaArchivosFacturacion } = this.state;
    servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.objeto.busqueda });
  }

  columna_uso_cfdi = (rowData, column) => {
    console.log(rowData);
    return (
      <div className="p-clearfix">
        <span >{rowData.usoCfdi.clave} - {rowData.usoCfdi.descripcion}</span>
      </div>
    );

  }

  actualizaReceptor = (receptor) => {
    this.setState({ receptor });
  }

  actualizaErroresFrmDatosFiscales = (erroresFrmDatosFiscales) => {
    this.setState({ erroresFrmDatosFiscales });
  }

  templateErrorResultado = (rowData, column) => {
    if (rowData.error === true)
        return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
    else
        return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
}


  render() {
    let {urlRegimenFiscal, urlBusquedaUsosCfdi,erroresFrmDatosFiscales,listaRegimenFiscalReceptor, receptor, erroresRequeridos, listaTabla, usosCfdi, erroresFrmDatos, concepto, listaMateriales, listaAtributos, botonEditarConcepto, comprobante,listaReceptorConfirmacion,
      mostrarModalResultado,listaResultados , urlBusquedaReceptor} = this.state;


    const dialogFooter = (
      <div >
        <Button icon="pi-md-check" onClick={this.guardarReceptor} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={() => this.setState({ receptor: {}, mostrarMoldaReceptor: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogFooterConcepto = (
      <div>
        {botonEditarConcepto ? <Button icon="pi-md-check" onClick={this.editarConcepto} label="Editar" className="teal-btn flat-btn" /> : <Button icon="pi-md-check" onClick={this.guardarConcepto} label="Guardar" className="teal-btn flat-btn" />}
        <Button icon="pi-md-close" onClick={() => this.setState({ concepto: { cantidad: 0.00, unidad: "PEAJE", costo: 0.0, atributos: {} }, modalConceptos: false })} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const formasPagos = [
      { name: '01-Efectivo', code: '01' },
      { name: '02-Cheque nominativo', code: '02' },
      { name: '03-Transferencia electrónica de fondos', code: '03' },
      { name: '04-Tarjeta de crédito', code: '04' },
      { name: '05-Monedero electrónico', code: '05' },
      { name: '06-Dinero electrónico', code: '06' },
      { name: '08-Vales de despensa', code: '07' },
      { name: '12-Dación en pago', code: '12' },
      { name: '13-Pago por subrogación', code: '13' },
      { name: '14-Pago por consignación', code: '14' },
      { name: '15-Condonación', code: '15' },
      { name: '17-Compensación', code: '17' },
      { name: '23-Novación', code: '23' },
      { name: '24-Confusión', code: '24' },
      { name: '25-Remisión de deuda', code: '25' },
      { name: '26-Prescripción o caducidad', code: '26' },
      { name: '27-A satisfacción del acreedor', code: '27' },
      { name: '28-Tarjeta de débito', code: '28' },
      { name: '29-Tarjeta de servicios', code: '29' },
      { name: '30-Aplicación de anticipos', code: '30' },
      { name: '31-Intermediario pagos', code: '31' },
      { name: '99-Por definir', code: '99' }
    ];

    const facturas = [
      { name: 'Ingreso', code: 'I' },
      { name: 'Egreso', code: 'E' }
    ];

    const dialogFooterConfirmacionFacturacion = (
      <div>
        <Button icon="pi-md-check" onClick={this.facturar} label="Facturar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion_facturacion} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const piePaginaModalRestultados = (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
      </div>
    );

    return (<div>
      <div className="content-section implementation">
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title">

            <div className="p-grid p-fluid">
            <div className="p-col-12  p-md-4">
              <Button label="Facturas de pago Origen" className="blue-grey-btn flat-btn" />
            </div>
            <div className="p-col-12  p-md-4">
             <Link to={{
          pathname: "/Capufe/bienvenido/adminPagos",
          state: {}
      }} > <Button label="Facturas de Recepción de pago" className="blue-grey-btn flat-btn" ></Button> </Link>
            </div>
          

           

            </div>
          <h1>Crear factura de pago</h1>
       
          <br />
        
        </div>
      </div>
    

      <Receptor receptor={receptor} erroresFrmDatosFiscales={erroresFrmDatosFiscales} urlBusquedaReceptor={urlBusquedaReceptor} urlRegimenFiscal={urlRegimenFiscal} urlBusquedaUsosCfdi={urlBusquedaUsosCfdi} actualizaReceptor={this.actualizaReceptor} actualizaErroresFrmDatosFiscales={this.actualizaErroresFrmDatosFiscales} />
      


      <br />

      <div className="card card-w-title">
        <div className="p-grid p-fluid">
          <div className="p-col-12  p-md-4">
            <Button label="Nuevo Concepto" className="blue-grey-btn flat-btn" onClick={this.nuevoConcepto} />
          </div>
        </div>
        <div className="p-col-12">
          <DataTable value={this.state.conceptos} header="Conceptos o Servicios del Comprobante" scrollable={true} scrollHeight="280px">
            <Column header="Editar" body={this.columnaEditarConcepto} style={{ width: '100px' }} />
            <Column field="cantidad" header="Cantidad" autoLayout={true} style={{ width: '80px' }} />
            <Column field="unidad" header="Unidad" autoLayout={true} style={{ width: '80px' }} />
            <Column field="descripcion" header="Descripción" autoLayout={true} style={{ width: '200px' }} />
            <Column body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.columna_costo} header="Costo" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_iva} header="Iva Trasladado" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_retenido} header="Iva Retenido" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_retenido_isr} header="Isr Retenido" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total} header="Total" autoLayout={true} style={{ width: '100px' }} />
          </DataTable>

        </div>
      </div>

      <Dialog header="Conceptos, los campos con * son requeridos." blockScroll visible={this.state.modalConceptos} modal={true} footer={dialogFooterConcepto} style={{ width: '60vw' }} onHide={() => this.setState({ concepto: { cantidad: 0.00, costo: 0.00, unidad: "PEAJE", atributos: {} }, modalConceptos: false, erroresRequeridos: {}, datoinformativo: {}, metodoPago: {} })}>
      <ScrollPanel style={{width: '100%', height: '300px'}}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-2">
            <label htmlFor="cantidad">* Cantidad:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="cantidad" name="concepto.cantidad" value={concepto.cantidad || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.cantidad ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
            {erroresRequeridos.cantidad ? <div> <Message severity="error" text={erroresRequeridos.cantidad} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="cantidad">* Concepto:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <Dropdown id="ingresodiverso" value={concepto.ingresodiverso || ''} options={listaMateriales} onChange={(e) => this.buscar_atributos(e)} optionLabel="descripcion" placeholder="Selecciona" autoWidth={false} />
            {erroresRequeridos.ingresodiverso ? <div> <Message severity="error" text={erroresRequeridos.ingresodiverso} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="costo">* Costo:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="costo" name="concepto.costo" value={concepto.costo || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.costo ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
            {erroresRequeridos.costo ? <div> <Message severity="error" text={erroresRequeridos.costo} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="total">Total:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="total" style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(concepto.total)}</div>
          </div>
        </div>
        {listaAtributos.map(
          (materialConcepto, index) =>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <label htmlFor={materialConcepto.nombre}>{materialConcepto.nombre}:</label>
              </div>
              <div className="p-col-12 p-md-8">
                <InputText id={index} name={materialConcepto.nombre} value={concepto.atributos[materialConcepto.nombre] || ''} placeholder={materialConcepto.nombre} onChange={this.asignarValorLista} />

              </div>
            </div>
        )
        }
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-2">
            <label htmlFor="textarea">Descripción detallada:</label>
          </div>
          <div className="p-col-10">
            <InputTextarea rows={3} cols={30} placeholder="Descripción" autoResize={true} name="concepto.descripcionDetallada" value={concepto.descripcionDetallada || ''} onChange={this.asignarValoresObjeto} />
          </div>
        </div>
        </ScrollPanel>
      </Dialog>
      <h3><label>Importe sobre el comprobante</label></h3>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>Subtotal</h4>
          <p>{servicioFormatos.formatearModena(comprobante.subTotal)}</p>
        </div>
        <div className="p-col-12 p-md-4">
          <h4>IVA</h4>
          <p>{servicioFormatos.formatearModena(comprobante.impuestos.totalImpuestosTrasladados)}</p>
        </div>
        <div className="p-col-12 p-md-4">
          <h4>Total</h4>
          <p>{servicioFormatos.formatearModena(comprobante.total)}</p>
        </div>
      </div>

      <div className="card card-w-title">
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>* Tipo de Comprobante:</h4>
            <Dropdown id="tipoDeComprobante" name="tipoDeComprobante" value={this.state.tipoDeComprobante} options={facturas} onChange={(e) => this.setState({ tipoDeComprobante: e.target.value })} optionLabel="name" placeholder="Selecciona" autoWidth={false} className={erroresFrmDatos.tipoDeComprobante ? 'p-error' : ''}/>
            {erroresFrmDatos.tipoDeComprobante ? <div> <Message severity="error" text={erroresFrmDatos.tipoDeComprobante} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>* Forma de pago:</h4>
            <Dropdown id="formapago" name="formaPago" value={this.state.formaPago} options={formasPagos} onChange={(e) => this.setState({ formaPago: e.target.value })}  optionLabel="name" placeholder="Selecciona" autoWidth={false} className={erroresFrmDatos.formaPago ? 'p-error' : ''}/>
            {erroresFrmDatos.formaPago ? <div> <Message severity="error" text={erroresFrmDatos.formaPago} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>Lugar de expedicion:</h4>
            <InputText id="tipoCambio" name="comprobante.lugarExpedicion" value={comprobante.lugarExpedicion || ''} onChange={this.asignarValoresObjeto} />
          </div>
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <Button label="Generar Comprobante" className="indigo-btn flat-btn" onClick={this.prefactura} />
        </div>
      </div>

      <Dialog header="Confirmación Facturación" visible={this.state.confirmacionFacturacion} modal={true} style={{ width: '80vw' }} footer={dialogFooterConfirmacionFacturacion} onHide={this.cerrar_modal_confirmacion_facturacion}>
      <ScrollPanel style={{width: '100%', height: '300px'}}>
        <DataTable value={listaReceptorConfirmacion} paginatorPosition="both" selectionMode="single" header="Datos del Receptor" responsive={true}>
          <Column field="rfc" header="R.F.C" sortable={true} />
          <Column field="nombre" header="Nombre o Razón Social" sortable={true} />
          <Column body={this.columna_uso_cfdi} header="UsoCfdi" sortable={true} />
          <Column field="correo" header="Correo" sortable={true} />
        </DataTable>
        <DataTable value={this.state.conceptos} header="Conceptos o Servicios del Comprobante" responsive={true}>
          <Column field="cantidad" header="Cantidad" autoLayout={true} />
          <Column field="unidad" header="Unidad" autoLayout={true} />
          <Column field="descripcion" header="Descripción" autoLayout={true} />
          <Column body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.columna_costo} header="Costo" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_iva} header="Iva Trasladado" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_retenido} header="Iva Retenido" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total_retenido_isr} header="Isr Retenido" autoLayout={true} style={{ width: '100px' }} />
            <Column body={this.total} header="Total" autoLayout={true} style={{ width: '100px' }} />
        </DataTable>
        </ScrollPanel>
      </Dialog>

      <Dialog header="Resultado facturación" visible={mostrarModalResultado} style={{ width: '80vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
      <ScrollPanel style={{width: '100%', height: '300px'}}>
        <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
          <Column body={this.templateErrorResultado} header="Estado" />
          <Column field="mensaje" header="Observación" />
          <Column field="objeto.uuid" header="UUID" />
          <Column field="objeto.serie" header="Serie" />
          <Column field="objeto.folio" header="Folio" />
          <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
        </DataTable>
        </ScrollPanel>
      </Dialog>

    </div>);
  }
}